import React from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import { Stream } from '@cloudflare/stream-react';
import styled from 'styled-components';
import CustomLightboxContainer from './CustomLightboxContainer';

const StyledVideo = styled.video`
  width: 70vw;
  max-height: 80vh;
  user-select: all;
  pointer-events: all;
  background-color: black;

  @media (max-width: 959px) {
    width: 90vw;
  }
`;

const isMSIE = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;

const VideoLightbox = ({ src, cfStreamId, ...props }) => {
  if (cfStreamId && !isMSIE) {
    return (
      <CustomLightboxContainer {...props}>
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <Stream
          autoplay
          controls
          src={cfStreamId}
          width="70vw"
        />
      </CustomLightboxContainer>
    );
  }

  const msieUrl = `https://videodelivery.net/${cfStreamId}/manifest/video.m3u8`;

  return (
    <CustomLightboxContainer {...props}>
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      <ReactPlayer
        url={(cfStreamId && isMSIE) ? msieUrl : src}
        config={{
          file: {
            attributes: {
              controls: true,
              controlsList: 'nodownload noremoteplayback',
              autoPlay: true,
              playsInline: true,
              disablePictureInPicture: true,
            },
          },
        }}
        width="100%"
        height="100%"
        style={{
          maxWidth: '70vw',
          maxHeight: '80vh',
        }}
      />
    </CustomLightboxContainer>
  );
};

VideoLightbox.propTypes = {
  src: PropTypes.string,
  cfStreamId: PropTypes.string,
};

VideoLightbox.defaultProps = {
  src: null,
  cfStreamId: null,
};

export default VideoLightbox;
